import api from './api';
import Phoner from './lib/Phoner';
import Socket from './socket';
import decrypt from './lib/decryptor';

interface Config {
    credential:{
        host: string|null;
        token: string|null;
        userkey: string|null;
    };
    config?:{
        dom?:{
            localVideo  : HTMLElement;
            remoteVideo : HTMLElement;
        }
    }
}
interface Callback{
    [key:string] : (e:any)=>{}
}

export default class IonPhoner {

    private phone:Phoner|null = null;
    private ws:Socket|null = null;
    private wsAct:Socket|null = null;
    private sk:string = '';
    private isConnected:boolean = false;
    private isRegistered:boolean = false;
    private isOnCall:boolean = false;
    private opt:Config = {credential:{host:null,token:null,userkey:null}}

    private callback:Callback = {
                                    "connection-status": (e:any)=>{ return e },
                                    "registration-status": (e:any)=>{ return e },
                                    "call-status": (e:any)=>{ return e },
                                    "auto-dial": (e:any)=>{ return e },
                                    "info": (e:any)=>{ return e },
                                    "queue": (e:any)=>{ return e },
                                };

    constructor(params:Config){
        this.opt.credential.host     = params?.credential.host || '';
        this.opt.credential.token    = params?.credential.token || '';
        this.opt.credential.userkey  = params?.credential.userkey || '';
        this.opt.config              = params.config;
        this.sk                     = this.setSk(params?.credential?.token||'');
    }

    async connect():Promise<{status:boolean, result:string|null}>{
        try {

            const self      = this;
            const host      = this.opt.credential.host as string;
            const token     = this.opt.credential.token as string;
            const userkey   = this.opt.credential.userkey as string;
            
            if (host.length  && token.length  && userkey.length ){
                
                const payload   = {method:'post', data:{userkey}}
                const url       = `${host}/api/connect`;
                const data      = await api(url, token, payload);
                
                if(data?.status){
                    const dataKey       = data?.result || ''
                    const credRaw       = decrypt(this.sk, dataKey);
                    const cred          = JSON.parse(credRaw);
                    
                    const wsHost        = cred?.phoner?.widget?.ws || ''; 
                    const wsToken       = cred?.phoner?.token || ''; 
                    this.ws             = new Socket(wsHost, wsToken);
                    this.ws.connect()

                    const wsActHost     = cred?.phoner?.remote?.ws || ''; 
                    const wsActToken    = cred?.phoner?.remote.token || ''; 
                    this.wsAct          = new Socket(wsActHost, wsActToken);
                    this.wsAct.connect()

                    const wsInit        = {
                                            category:"activity",
                                            name:"CONNECTION",
                                            payload:{
                                                status:"DISCONNECTED"
                                            }
                                        }
                    this.wsSend(wsInit)
                    
                    const domConfig     = this.opt.config;
                    const credentials   = {
                                            extension: cred?.pbx?.extension || 0, 
                                            password: cred?.pbx?.password || null, 
                                            host: cred?.pbx?.host || null, 
                                            port: cred?.pbx?.port || null, 
                                            ws: cred?.pbx?.ws || null
                                        }
                    const params        = {credentials, config:domConfig}
                    this.phone          = new Phoner(params);

                    this.phone?.init();

                    this.phone.activity((e:any,data:any)=>{
                        
                        if(e=='connectionStatus') {
                            const payload = data?.payload||null;
                            this.callback['connection-status'](payload);
                            this.isConnected = payload?.status=='ESTABLISHED';
                            if(!this.isConnected) this.isRegistered = false;


                            const wsInit        = {
                                                    category:"activity",
                                                    name:"CONNECTION",
                                                    payload:{
                                                        status:payload?.status||"CONNECTING"
                                                    }
                                                }
                            this.wsSend(wsInit)
                        }

                        if(e=='registrationStatus') {
                            const payload = data?.payload||null;
                            this.callback['registration-status'](payload)
                            this.isRegistered = payload?.status=='REGISTERED';

                            const wsInit        = {
                                                    category:"activity",
                                                    name:"REGISTRATION",
                                                    payload:{
                                                        status:payload?.status||"CONNECTING"
                                                    }
                                                }
                            this.wsSend(wsInit)
                        }
                        if(e=='callStatus') {
                            const payload = data?.payload||null;
                            this.callback['call-status'](payload)
                            this.isOnCall = payload?.status=='ESTABLISHED';



                            const wsInit        = {
                                                    category:"activity",
                                                    name:"CALL_STATUS",
                                                    payload:{
                                                        status  : payload?.status||"FINISH",
                                                        call_id : payload?.callNum||"",
                                                        type    : payload?.type||"",
                                                    }
                                                }
                            this.wsSend(wsInit)
                        }
                    })

                    this.ws.onMessage((e:any)=>{
                        // console.log(e);
                        if(e){}
                    })

                    this.wsAct.onMessage((e:any)=>{
                        try {
                            const msg           = e

                            // console.log('msg', msg);
                            
                            const isOnCall      = self.phone?.currentCall ? true : false

                            const sender        = msg.from;
                            const statusPhone   = {status:true, result:{
                                                    connection: self.isConnected, registration: self.isRegistered, isOnCall }
                                                  }
                            const callbackMsg   = {category:"CALLBACK", userkey:sender, message:statusPhone}

                            if(msg?.category ==="INFO" && msg.message.action==="PHONESTATUS"){ 
                                self.wsAct?.send(JSON.stringify(callbackMsg))
                            }

                            if(msg?.category ==="COMMAND" && msg.message.action==="DIAL"){
                                
                                self.wsAct?.send(JSON.stringify(callbackMsg))

                                const number    = msg.message.payload.number || null;
                                
                                if(!self.phone?.currentCall) self.phone?.call(number, false);
                            }

                            if(msg?.category ==="COMMAND" && msg.message.action==="HANGUP"){
                                self.phone?.hangup();
                                self.wsAct?.send(JSON.stringify(callbackMsg))
                            }
                        } catch (error) {
                            
                        }
                    })

                    return { status: true, result: null };
                }else{
                    return { status: false, result: 'invalid credential' };
                }
                
            }else{
                return { status: false, result: 'invalid credential' };
            }

        } catch (error) {
            const message = error && (error as any).message ? (error as any).message : String(error);
            return { status: false, result: message };
        }
    }

    private wsSend(msg:object){
        if(this.ws){
            this.ws.send(JSON.stringify(msg))
        }
    }

    register(){
        this.phone?.connect()
    }

    unregister(){
        this.phone?.disconnect()
    }

    call(phone:string){
        if (!this.isRegistered || !phone.length) {
            console.log("Cannot make a call.");
            return;
        }
         if(!this.phone?.currentCall)  this.phone?.call(phone, false)
    }


    dtmf(num:string){
        if (!this.isOnCall || !num.length) {
            console.log("No current call to send DTMF.");
            return;
        }

        this.phone?.sendDTMF(num)
    }

    hangup(){
        this.phone?.hangup();
    }

    answer(){
        this.phone?.answer();
    }

    hold(){
        this.phone?.hold()
    }

    unhold(){
        this.phone?.unhold()
    }

    mute(){
        this.phone?.mute()
    }

    unmute(){
        this.phone?.unmute()
    }

    private setSk(token:string):string{
        const passkey   = token?.replaceAll('-','')?.split('')?.reverse()?.join('');
        const sk        = passkey+'@'+this.opt.credential.userkey;
        return sk
    }

    on(event:keyof Callback, handler:(e:any)=>any){
        try {
            this.callback[event]=handler   
        } catch (error) {
            console.error('invalid event name');
        }
    }
}